module.exports = __webpack_public_path__ + "img/img-related07.6bf60272.jpg";